import React from "react";
var __jsx = React.createElement;
import { stringToListItems } from "@/utils/stringHelpers";
import stl from "./ReturnsTermsAndConditions.module.css";
import { useTranslation } from "@i18n";
var ReturnsTermsAndConditions = function ReturnsTermsAndConditions() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: stl.termsTitle
  }, tShort("return_policy_title", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.termsContent,
    dangerouslySetInnerHTML: {
      __html: stringToListItems(tLong("return_policy_body", {
        ns: "web_tracking"
      }))
    }
  })));
};
export default ReturnsTermsAndConditions;